/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Suggests fixing typos in email addresses
 */

import mailcheck from 'mailcheck'
import React, { useCallback, useState, useEffect } from 'react'
import { SyntheticButton } from '../../Buttons/SyntheticButton/SyntheticButton'
import css from './InputEmail.module.scss'

interface InputEmailCheckerProps {
  children: React.ReactNode
  setValue: (value: string) => void
  value: string
}

export const InputEmailChecker = ({ children, setValue, value }: InputEmailCheckerProps) => {
  const [suggestion, setSuggestion] = useState<string>()

  useEffect(() => {
    mailcheck.run({
      email: value,
      suggested: (suggestion: MailcheckModule.ISuggestion) => {
        if (suggestion.full) {
          setSuggestion(suggestion.full)
        }
      },
      empty: () => setSuggestion(undefined),
    })
  }, [value])

  const onClick = useCallback(() => {
    if (suggestion !== undefined) {
      setValue(suggestion)
    }
  }, [setValue, suggestion])

  const onHide = useCallback(() => {
    setSuggestion(undefined)
  }, [])

  return (
    <div className={css.container}>
      {children}
      {suggestion && (
        <div className={css.tooltipContainer}>
          <div className={css.emailTooltip}>
            <div>Did you mean</div>
            <SyntheticButton className={css.suggestion} onClick={onClick}>
              {suggestion}
            </SyntheticButton>
            ?
            <SyntheticButton className={css.emailTooltipX} onClick={onHide}>
              x
            </SyntheticButton>
          </div>
        </div>
      )}
    </div>
  )
}
